import React from "react";
import { mdiPrinter } from "@mdi/js";
import Icon from "@mdi/react";

export default function DownloadPDFButton({ fileName = "Relatório" }) {
  const handleDownloadPDF = () => {
    // For large reports, directly use browser print which handles pagination better
    const style = document.createElement('style');
    style.id = 'print-pdf-styles';
    style.textContent = `
      @media print {
        /* Hide elements that shouldn't be printed */
        .no-print, 
        .btn, 
        button,
        nav,
        .navbar { 
          display: none !important; 
        }
        
        /* Ensure content uses full page */
        body { 
          margin: 0;
          padding: 10mm;
          background: white;
        }
        
        .container { 
          max-width: 100% !important;
          width: 100% !important;
          padding: 0 !important;
        }
        
        /* Table styling for print */
        table { 
          width: 100%;
          border-collapse: collapse;
          page-break-inside: auto;
          font-size: 10pt;
        }
        
        tr { 
          page-break-inside: avoid;
          page-break-after: auto;
        }
        
        td, th {
          padding: 4px 8px;
          border: 1px solid #000;
        }
        
        thead {
          display: table-header-group;
        }
        
        /* Keep headers with content */
        h1, h2, h3, h4, h5, h6 {
          page-break-after: avoid;
        }
        
        /* Each user section starts on new page */
        .mb-5 {
          page-break-before: auto;
          page-break-after: auto;
        }
        
        /* First user shouldn't have page break before */
        .mb-5:first-of-type {
          page-break-before: avoid;
        }
        
        /* Ensure images fit */
        img {
          max-width: 100%;
          height: auto;
        }
      }
      
      @page {
        size: A4;
        margin: 10mm;
      }
    `;
    
    // Add the style to head
    document.head.appendChild(style);
    
    // Store original title
    const originalTitle = document.title;
    document.title = fileName;
    
    // Show print dialog after a brief delay to ensure styles are applied
    setTimeout(() => {
      window.print();
      
      // Cleanup after printing
      setTimeout(() => {
        document.title = originalTitle;
        const printStyle = document.getElementById('print-pdf-styles');
        if (printStyle) {
          printStyle.remove();
        }
      }, 1000);
    }, 100);
  };

  return (
    <button
      className="btn btn-primary rounded-circle position-fixed no-print"
      style={{
        width: "56px",
        height: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bottom: "22px",
        right: "22px",
      }}
      onClick={handleDownloadPDF}
      title="Imprimir / Salvar como PDF"
    >
      <Icon path={mdiPrinter} size={1} color="white" />
    </button>
  );
}